import classNames from 'classnames'
import React from 'react'
import scs from '../cards/card/card.scss'
import cs from '../cards/cards.scss'
import ls from '../list-layout/list-layout.scss'
import ss from '../single-event/single-event.scss'
import ts from '../single-event/title/title.scss'
import s from './empty-state.scss'
import {EmptyStateProps} from '.'

export const EmptyState = ({singleEventWidget, listLayout, t}: EmptyStateProps) => {
  return (
    <div
      className={classNames(s.container, {
        [ss.fullLayout]: singleEventWidget,
        [ls.listContainer]: !singleEventWidget && listLayout,
        [cs.card]: !singleEventWidget && !listLayout,
        [ts.root]: singleEventWidget,
        [scs.evCardContentFont]: !singleEventWidget,
        [scs.evCardContentColor]: !singleEventWidget,
      })}
    >
      {t('widgetEmptyStateNotification')}
    </div>
  )
}
